var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_2220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56293 4.35364V13.6474C9.56293 14.5878 8.99464 15.4105 8.11509 15.7433C7.85229 15.8427 7.58129 15.891 7.31399 15.891C6.68818 15.8911 6.08216 15.6266 5.64585 15.1349L3.61619 12.8966C3.3767 12.6326 2.99334 12.4811 2.63684 12.4811C1.18289 12.4811 0 11.2983 0 9.84431L0 8.36768C0 6.91373 1.18289 5.73084 2.63684 5.73084C3.01032 5.73084 3.36274 5.56722 3.60378 5.28191L5.60451 2.91403C6.21675 2.18356 7.19097 1.92188 8.08697 2.24726C8.98356 2.57293 9.56293 3.39974 9.56293 4.35364ZM8.15662 4.35364C8.15662 3.81094 7.73585 3.61599 7.60689 3.56913C7.55236 3.54933 7.44077 3.51636 7.3039 3.51636C7.11703 3.51636 6.88285 3.57778 6.68185 3.81798L4.678 6.18958C4.16919 6.79173 3.42522 7.13716 2.63684 7.13716C1.95833 7.13716 1.40631 7.68917 1.40631 8.36768V9.84431C1.40631 10.5228 1.95833 11.0748 2.63684 11.0748C3.38936 11.0748 4.15242 11.3946 4.65792 11.952C4.65792 11.952 6.69433 14.1977 6.69633 14.1999C7.05051 14.601 7.49083 14.4759 7.61733 14.428C7.74386 14.3801 8.15662 14.1824 8.15662 13.6474V4.35364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.698,
    y: 1.43814,
    width: 1.8,
    height: 18.1558,
    rx: 0.9,
    transform: "rotate(38.3297 11.698 1.43814)",
    fill: "white",
    stroke: "#4614A6",
    strokeWidth: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_2220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume-mute.28cb005959c5c51805c5f79469d3bca0.svg";
export { ForwardRef as ReactComponent };